import { ACCESS_CACHE_TTL_MS, accessSnapshotKey } from "../../platformAccess/auth/accessCachePolicy";

export const ACCESS_CLEARED = "access/cleared";
export const ACCESS_REQUESTED = "access/requested";
export const ACCESS_RECEIVED = "access/received";
export const ACCESS_FAILED = "access/failed";

const initialState = {
  uid: null,
  identityKey: null,
  context: null,
  fetchedAt: null,
  expiresAt: null,
  status: "idle",
  refreshing: false,
  error: null,
  refreshError: null,
  retryAt: 0,
  failures: 0,
  requestId: null,
};

export default function accessReducer(state = initialState, { type, payload } = {}) {
  if (type === ACCESS_CLEARED) return initialState;
  if (type === ACCESS_REQUESTED) {
    const previous = state.identityKey === payload.identityKey ? state : initialState;
    const background = payload.background && previous.context !== null;
    return {
      ...previous,
      uid: payload.uid,
      identityKey: payload.identityKey,
      requestId: payload.requestId,
      // A requested revalidation makes the previous snapshot stale. If it
      // fails transiently, retryAt controls the retry rather than its old TTL.
      expiresAt: null,
      status: background ? "ready" : "loading",
      refreshing: Boolean(background),
      error: null,
      refreshError: null,
    };
  }
  if (state.requestId !== payload?.requestId || state.identityKey !== payload?.identityKey) return state;
  if (type === ACCESS_RECEIVED) {
    const context = accessSnapshotKey(state.context) === accessSnapshotKey(payload.context)
      ? state.context : payload.context;
    return {
      ...state,
      context,
      fetchedAt: payload.now,
      expiresAt: payload.now + ACCESS_CACHE_TTL_MS,
      status: "ready",
      refreshing: false,
      error: null,
      refreshError: null,
      retryAt: 0,
      failures: 0,
    };
  }
  if (type === ACCESS_FAILED) {
    const keepContext = payload.keepContext && state.context !== null;
    return {
      ...state,
      context: keepContext ? state.context : null,
      status: keepContext ? "ready" : "error",
      refreshing: false,
      error: keepContext ? null : payload.error,
      refreshError: keepContext ? payload.error : null,
      failures: state.failures + 1,
      retryAt: payload.retryAt,
    };
  }
  return state;
}
